"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

function _default(array, extras) {
  var map = (0, _objectSpread3.default)({}, [].reduce.call(array, function (map, value, index) {
    map[index] = value;
    return map;
  }, {}), extras, (0, _defineProperty2.default)({
    length: array.length
  }, Symbol.iterator, function () {
    return [].slice.call(map)[Symbol.iterator]();
  }));
  return map;
}